export const iconFontAwesomeSportsFitnessMound = (
	<i className="fa-solid fa-mound"></i>
);
